import { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import useRoutes from '../../../hooks/useRoutes';
import { GlobalLocationStateType } from '../../../types/types';

export const useDatasetExportNavigationGuard = () => {
  const { pathname, state } = useLocation<GlobalLocationStateType>();
  const { datasetId } = useParams<{ datasetId: string }>();
  const history = useHistory();
  const routes = useRoutes();

  useEffect(() => {
    if (!state?.openExport) {
      return;
    }

    // Subset grid export navigates here first so the dataset provider is scoped to that subset.
    history.replace(pathname, {
      ...state,
      openExport: false,
    });
    history.push(routes.datasetExport(datasetId, 'main'), {
      exportSelection: state.exportSelection,
      subsetPathname: pathname,
    });
  }, [datasetId, history, pathname, routes, state]);
};
